export default __webpack_public_path__ + "static/media/front-card.1451b5f2.svg";